import React, { useState } from "react";

export default function DownloadStabilityCSV({ summary }) {
    const [rows, setRows] = useState(null)
    const titles = [
        "COMPONENT",
        "LANGUAGE",
        "SCOPE",
        "VERSION",
        "LATEST MAJOR",
        "LATEST MINOR",
        "LATEST PATCH",
    ];
    const populateRows = () => {
        const rows = [];
        summary.reports.forEach((report) => {
            report.versions.forEach((version) => {
                const row = [];
                row.push(version.name);
                row.push(report.language);
                row.push(version.scope);
                row.push(version.version);
                row.push(version.latestMajor);
                row.push(version.latestMinor);
                row.push(version.latestPatch);
                rows.push(row);
            });
        });
        setRows(rows);
        return rows
    };
    const convertToCsv = (rows) => {
        const cvsRows = [titles]
        rows.forEach((row) => {
            cvsRows.push(row.join(","))
        })
        return cvsRows.join("\n")
    }
  const download = () => {
    let localRows = rows
    if (!localRows) {
        localRows = populateRows()
    }
    const csvFormat = convertToCsv(localRows)
    const file = new File([csvFormat], "stability.csv", {type: "text/csv"})
    const anchor = document.createElement("a")
    const url = URL.createObjectURL(file)
    anchor.download = file.name
    anchor.href = url
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  };
  return (
    <span onClick={download} style={{ cursor: "pointer", marginLeft: "10px" }} title="Export to csv format">
      <i className="fa-solid fa-file-csv"></i>
    </span>
  );
}
